import { tvpil } from '../../compat/tvpil';
import { createUserUnauthorizedError } from '../../errors';
import { fetchFavoriteChannels } from '../../favorite';
import { fetchLastWatched } from '../../lastWatched';
import { fetchMostWatched } from '../../mostWatched';
import { fetchPersonalLineup } from '../../personalLineup';

import { ChannelsPersonalization } from './types';

type FetchChannelsPersonalizationArgs = {
  referenceId: string;
  pageReferenceId?: string;
};

export async function fetchChannelsPersonalization({
  referenceId,
  pageReferenceId,
}: FetchChannelsPersonalizationArgs): Promise<ChannelsPersonalization | undefined> {
  const isPersonalLineupEnabled = tvpil.rootStore.isPersonalLineupEnabled;
  const isFavoriteChannelPersonalization = tvpil.rootStore.isFavoriteChannelPersonalization;

  if (!tvpil.userId) {
    throw createUserUnauthorizedError();
  }

  if (isPersonalLineupEnabled) {
    const [lastWatched, personalLineup] = await Promise.all([
      pageReferenceId ? fetchLastWatched({ referenceId, pageReferenceId }) : Promise.resolve(undefined),
      fetchPersonalLineup(),
    ]);

    return {
      lastWatched,
      personalLineup,
    };
  }

  if (isFavoriteChannelPersonalization) {
    const [lastWatched, favoriteChannels, mostWatched] = await Promise.all([
      pageReferenceId ? fetchLastWatched({ referenceId, pageReferenceId }) : Promise.resolve(undefined),
      fetchFavoriteChannels(),
      fetchMostWatched({ referenceId, userId: tvpil.userId }),
    ]);

    return {
      favoriteChannels,
      lastWatched,
      mostWatched,
    };
  }

  if (!pageReferenceId) {
    return {
      lastWatched: undefined,
    };
  }

  const lastWatched = await fetchLastWatched({ referenceId, pageReferenceId });

  return {
    lastWatched,
  };
}
